import { deleteDoc, doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase/config";

type NotificationPermissionState = {
  granted: boolean;
  denied: boolean;
  default: boolean;
};

function gmtHourForLocalHour(localHour: number): number {
  const probe = new Date();
  probe.setHours(localHour, 0, 0, 0);
  return probe.getUTCHours();
}

/**
 * Website onboarding stores the reminder hour for the native apps.
 * It does not register a service worker or an FCM token.
 */
class NotificationService {
  getPermissionState(): NotificationPermissionState {
    return { granted: false, denied: false, default: true };
  }

  async requestPermission(): Promise<boolean> {
    return false;
  }

  async saveDailyReminder(userId: string, localHour: number): Promise<void> {
    const gmtHour = gmtHourForLocalHour(localHour);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userRef = doc(db, "users", userId);
    const userDoc = await getDoc(userRef);
    const previous = userDoc.data()?.reminderGmtHour;
    if (typeof previous === "number" && previous !== gmtHour) {
      await deleteDoc(doc(db, "reminders", String(previous), "users", userId)).catch(() => {});
    }

    await setDoc(doc(db, "reminders", String(gmtHour), "users", userId), {
      userId,
      localHour,
      gmtHour,
      timezone,
      enabled: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    await setDoc(userRef, { reminderGmtHour: gmtHour }, { merge: true });
  }
}

export const notificationService = new NotificationService();
